<script setup>
import { TabsContent } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  value: { type: String, required: true },
  forceMount: { type: Boolean, default: undefined },
  class: { type: String, default: undefined },
});
</script>

<template>
  <TabsContent
    data-slot="tabs-content"
    :value="props.value"
    :force-mount="props.forceMount"
    :class="cn('flex-1 outline-none', props.class)"
  >
    <slot />
  </TabsContent>
</template>
